import React from "react";
import { motion } from "framer-motion";
import Reveal from "./Reveal";
import { services } from "../data/content";
import {
  FiSmartphone,
  FiCode,
  FiServer,
  FiGrid,
  FiAward,
  FiYoutube,
} from "react-icons/fi";

const ICONS = {
  phone: FiSmartphone,
  code: FiCode,
  server: FiServer,
  dashboard: FiGrid,
  graduation: FiAward,
  youtube: FiYoutube,
};

export default function Services() {
  return (
    <section id="services" className="section">
      <div className="container">
        <Reveal>
          <div className="eyebrow">What I Do</div>
          <h2 className="section-title">
            One team. <span className="gradient-text">Full ownership.</span>
          </h2>
          <p className="section-sub">
            From wireframe to production — mobile, web, backend, and the people behind it.
            No handoffs, no gaps.
          </p>
        </Reveal>

        <div
          className="services-grid"
          style={{
            marginTop: 56,
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: 22,
          }}
        >
          {services.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.title} delay={(i % 3) * 0.08}>
                <motion.div
                  whileHover={{ y: -8 }}
                  transition={{ type: "spring", stiffness: 300, damping: 20 }}
                  className="card"
                  style={{ height: "100%" }}
                >
                  <div
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: 12,
                      background: "linear-gradient(135deg, rgba(0,229,255,0.12), rgba(168,85,247,0.12))",
                      border: "1px solid var(--border-strong)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: 20,
                      color: "var(--accent)",
                    }}
                  >
                    <Icon size={22} />
                  </div>
                  <h3 style={{ fontSize: 20, marginBottom: 10 }}>{s.title}</h3>
                  <p style={{ color: "var(--text-muted)", fontSize: 15, lineHeight: 1.65, marginBottom: 20 }}>
                    {s.description}
                  </p>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                    {s.stack.map((t) => (
                      <span key={t} className="tag">
                        {t}
                      </span>
                    ))}
                  </div>
                </motion.div>
              </Reveal>
            );
          })}
        </div>
      </div>

      <style>{`
        @media (max-width: 960px) {
          .services-grid { grid-template-columns: repeat(2, 1fr) !important; }
        }
        @media (max-width: 620px) {
          .services-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
